/**
 * 一些常用的格式化
 */
/**
 * 格式化数字，100000 -> 10万
 */
export function formatCount(count) {
    var divide = 10000;
    var max = divide * 10000;
    if (count < divide) {
        return "".concat(count);
    }
    else if (count < max) {
        return "".concat((count / divide).toFixed(1), "\u4E07");
    }
    else {
        return "".concat((count / max).toFixed(1), "\u4EBF");
    }
}
/**
 * 字符串时间戳转成 Date，并加上北京时间的时差
 * @param ts
 */
export function str2date(ts) {
    if (typeof ts !== 'string') {
        console.error(new TypeError('Invalid Date input:' + ts), ts); // eslint-disable-line
        return new Date();
    }
    return new Date(ts.replace(/\s+/g, 'T').concat('+08:00'));
}
/**
 * 格式化时间
 *
 * @param ts: 秒数（而不是毫秒）
 * formatTime(1453190264.781) => '10秒前'
 * copy from: https://github.intra.douban.com/Rexxar/rexxar-common/blob/971249e3d9b594a3e519c579282cd40d59151b5d/src/assets/js/utils.ts#L45
 */
export function formatTime(ts) {
    if (typeof ts === 'string') {
        var _ts = ts;
        ts = str2date(ts).getTime() / 1000;
        if (isNaN(ts)) {
            return _ts;
        }
    }
    var now = new Date();
    var currentTs = Math.floor(now.getTime() / 1000);
    var dts = currentTs - ts;
    var isFuture = dts < 0;
    dts = Math.abs(dts);
    var dDays = Math.floor(dts / 86400);
    var dHours = Math.floor(dts / 3600);
    var dMinutes = Math.floor(dts / 60);
    if (isFuture) {
        var date = new Date(ts * 1000);
        var todayRemain = (new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime() - now.getTime()) / 1000;
        var dDays_1 = Math.floor((dts + 86400 - todayRemain) / 86400);
        var time = "".concat(('0' + date.getHours()).slice(-2), ":").concat(('0' + date.getMinutes()).slice(-2));
        if (dDays_1 === 1) {
            return "\u660E\u5929 ".concat(time);
        }
        else if (dDays_1 === 2) {
            return "\u540E\u5929 ".concat(time);
        }
        else if (dDays_1 > 0 && dDays_1 < 4) {
            return "".concat(dDays_1, "\u5929\u540E ").concat(time);
        }
        else if (dDays_1 <= 0 && dHours > 0) {
            return "\u4ECA\u5929 ".concat(time);
        }
        else if (dHours <= 0 && dMinutes > 0) {
            return "".concat(dMinutes, "\u5206\u949F\u540E");
        }
        else if (dMinutes <= 0) {
            return "".concat(dts, "\u79D2\u540E");
        }
        else {
            var year = date.getFullYear();
            var yearStr = '';
            if (year !== now.getFullYear()) {
                yearStr = "".concat(year, "\u5E74");
            }
            return "".concat(yearStr).concat(date.getMonth() + 1, "\u6708").concat(date.getDate(), "\u65E5 ").concat(time);
        }
    }
    if (dDays > 0 && dDays < 4) {
        return "".concat(dDays, "\u5929\u524D");
    }
    else if (dDays <= 0 && dHours > 0) {
        return "".concat(dHours, "\u5C0F\u65F6\u524D");
    }
    else if (dHours <= 0 && dMinutes > 0) {
        return "".concat(dMinutes, "\u5206\u949F\u524D");
    }
    else if (dMinutes <= 0) {
        return '刚刚';
    }
    else {
        var s = new Date(ts * 1000);
        var year = s.getFullYear();
        var yearStr = '';
        if (year !== now.getFullYear()) {
            yearStr = "".concat(year, "\u5E74");
        }
        return "".concat(yearStr).concat(s.getMonth() + 1, "\u6708").concat(s.getDate(), "\u65E5");
    }
}
/**
 * 解析秒数
 */
export function parseDurationSeconds(seconds) {
    var h = Math.floor(seconds / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = seconds - h * 3600 - m * 60;
    return { h: h, m: m, s: s };
}
export function formatDurationSeconds(seconds, formater) {
    if (formater === void 0) { formater = 'chinese'; }
    var _a = parseDurationSeconds(seconds), h = _a.h, m = _a.m, s = _a.s;
    if (formater === 'chinese') {
        if (h > 0) {
            return "".concat(h, "\u5C0F\u65F6").concat(m, "\u5206\u949F");
        }
        if (m > 0) {
            return "".concat(m, "\u5206\u949F");
        }
        return "".concat(seconds, "\u79D2");
    }
    return [h * 60 + m, s].map(function (t) {
        if (t >= 10) {
            return t;
        }
        else if (t > 0) {
            return "0".concat(t);
        }
        return '00';
    }).join(':');
}
//# sourceMappingURL=format.js.map